import { render, staticRenderFns } from "./GasTable.vue?vue&type=template&id=2c239bca&scoped=true&"
import script from "./GasTable.vue?vue&type=script&lang=js&"
export * from "./GasTable.vue?vue&type=script&lang=js&"
import style0 from "./GasTable.vue?vue&type=style&index=0&id=2c239bca&lang=scss&scoped=true&"
import style1 from "./GasTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c239bca",
  null
  
)

export default component.exports